import Cookies from "js-cookie";

const TokenKey = "XSRF-TOKEN";

export function getToken() {
    let getKey = Cookies.get(TokenKey);
    if (getKey) {
        getKey = getKey.split(",")[0];
    }
    return getKey;
}

export function setToken(token) {
    return Cookies.set(TokenKey, token);
}

export function removeToken() {
    return Cookies.remove(TokenKey);
}